import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import BlogHomeModule from '@modules/Blog/Home'
import { initializeApollo, addApolloState } from '@utils/apollo'
import {
  getArticleCategories,
  getArticles,
  getPopularArticles,
} from '@gql/blogQuery'

const PAGE_SIZE = 5
const POPULAR_ARTICLE_LIMIT = 5

function BlogHomePage(props) {
  return (
    <BlogHomeModule
      PAGE_SIZE={PAGE_SIZE}
      POPULAR_ARTICLE_LIMIT={POPULAR_ARTICLE_LIMIT}
      {...props}
    />
  )
}

/**
 * getStaticProps
 *
 * @param {import('next').GetStaticPropsContext} ctx
 * @returns {import('next').GetStaticPropsResult}
 */
export async function getStaticProps(ctx) {
  const client = initializeApollo(undefined, ctx)

  await client.query({
    query: getArticleCategories,
  })

  await client.query({
    query: getPopularArticles,
    variables: {
      limit: POPULAR_ARTICLE_LIMIT,
    },
  })

  await client.query({
    query: getArticles,
    variables: {
      pageSize: PAGE_SIZE,
      page: 1,
      category: null,
      subcategory: null,
      keyword: null,
      tags: null,
    },
  })

  return addApolloState(client, {
    props: { ...(await serverSideTranslations(ctx.locale, ['common'])) },
    revalidate: 60 * 60, // 1 hour
  })
}

BlogHomePage.getLayout = BlogHomeModule.getLayout

export default BlogHomePage
